import { render, staticRenderFns } from "./VulnerabilityCard.vue?vue&type=template&id=87170f82&"
import script from "./VulnerabilityCard.vue?vue&type=script&lang=js&"
export * from "./VulnerabilityCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports